// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RQCalendar-module__Shift__Header__Text--d1Qf3 {
    font-size: 14px;
    padding: 0 3px 0 30px;
    display: flex;
  }
  
  .RQCalendar-module__Settings__Header__Text--vsehb {
    font-size: 14px;
    padding: 15px 3px 50px 15px;
    border-right: 1.5px solid #e6edf5;
  }
  
  .RQCalendar-module__Input_available--nEUIe {
    border: 0.5px solid #e6edf5;
    border-radius: 3px;
    margin: 5px 5px 5px 0px;
    padding-left: 5px;
    /* padding-bottom: 13px; */
    width: 100%;
    height: 44px;
  }
  
  .RQCalendar-module__Card__Container--rSP88 {
    box-shadow: none;
    border: 1px solid #e6edf5;
  }
  
  .RQCalendar-module__logoDrawer--cKCm5 {
    background-color: #6EA0D7;
    /* opacity: 0.5; */
    text-align: center;
    padding: 20px;
    margin: 20px;
    border: 1px solid #6ea0d7;
    border-radius: 3px;
    min-height: 1px;
  }
  
  .RQCalendar-module__logoImg--Gs_s1 {
    width: 80%;
  }
  
  .RQCalendar-module__logoEmployeeBillboard--UbLW9 {
    font-family: "Arial Black";
    font-size: 14px;
    display: inline-block;
  }
  
  .RQCalendar-module__logoPoweredBy--D0CdN {
    font-family: "Arial regular";
    font-size: 11px;
  }
  
  
  .RQCalendar-module__Button__Location--FYIK6 {
    margin: 5px auto !important;
    width: 100%;
  }
  
  button:focus {
    outline: none !important;
  }
  
  .RQCalendar-module__Ascending--gEZBC,
  .RQCalendar-module__Descending--BazkB {
    padding: 2px;
    margin-left: 1px;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  
  .RQCalendar-module__Descending--BazkB {
    transform: rotate(180deg);
  }
  
  .RQCalendar-module__ctrlSelection--cyhla {
    transition: color 0.25s;
  }
  
  .RQCalendar-module__ctrlSelection--cyhla {
    background: linear-gradient(90deg, #97b8ef 50%, transparent 50%), linear-gradient(90deg, #97b8ef 50%, transparent 50%), linear-gradient(0deg, #97b8ef 50%, transparent 50%), linear-gradient(0deg, #97b8ef 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 15px 4px, 15px 4px, 4px 15px, 4px 15px;
    background-position: 0px 0px, 200px 100px, 0px 100px, 200px 0px;
    padding: 10px;
    animation: RQCalendar-module__border-dance--qRo_K 4s infinite linear;
  }
  
  @keyframes RQCalendar-module__border-dance--qRo_K {
    0% {
      background-position: 0px 0px, 300px 46px, 0 150px, 86px 0, 0px 4px
    }
  
    100% {
      background-position: 300px 0px, 160px 46px, 0 0, 86px 179px, 0px 28px
    }
  }
  
  .RQCalendar-module__popover--YG1cl {
    pointer-events: none;
  }`, "",{"version":3,"sources":["webpack://./src/common/styles/RQCalendar.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;;EAGA;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,4GAA4G;EAC9G;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gOAAgO;IAChO,yDAAyD;IACzD,uDAAuD;IACvD,+DAA+D;IAC/D,aAAa;IACb,oEAA0C;EAC5C;;EAEA;IACE;MACE;IACF;;IAEA;MACE;IACF;EACF;;EAEA;IACE,oBAAoB;EACtB","sourcesContent":[".Shift__Header__Text {\r\n    font-size: 14px;\r\n    padding: 0 3px 0 30px;\r\n    display: flex;\r\n  }\r\n  \r\n  .Settings__Header__Text {\r\n    font-size: 14px;\r\n    padding: 15px 3px 50px 15px;\r\n    border-right: 1.5px solid #e6edf5;\r\n  }\r\n  \r\n  .Input_available {\r\n    border: 0.5px solid #e6edf5;\r\n    border-radius: 3px;\r\n    margin: 5px 5px 5px 0px;\r\n    padding-left: 5px;\r\n    /* padding-bottom: 13px; */\r\n    width: 100%;\r\n    height: 44px;\r\n  }\r\n  \r\n  .Card__Container {\r\n    box-shadow: none;\r\n    border: 1px solid #e6edf5;\r\n  }\r\n  \r\n  .logoDrawer {\r\n    background-color: #6EA0D7;\r\n    /* opacity: 0.5; */\r\n    text-align: center;\r\n    padding: 20px;\r\n    margin: 20px;\r\n    border: 1px solid #6ea0d7;\r\n    border-radius: 3px;\r\n    min-height: 1px;\r\n  }\r\n  \r\n  .logoImg {\r\n    width: 80%;\r\n  }\r\n  \r\n  .logoEmployeeBillboard {\r\n    font-family: \"Arial Black\";\r\n    font-size: 14px;\r\n    display: inline-block;\r\n  }\r\n  \r\n  .logoPoweredBy {\r\n    font-family: \"Arial regular\";\r\n    font-size: 11px;\r\n  }\r\n  \r\n  \r\n  .Button__Location {\r\n    margin: 5px auto !important;\r\n    width: 100%;\r\n  }\r\n  \r\n  button:focus {\r\n    outline: none !important;\r\n  }\r\n  \r\n  .Ascending,\r\n  .Descending {\r\n    padding: 2px;\r\n    margin-left: 1px;\r\n    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  }\r\n  \r\n  .Descending {\r\n    transform: rotate(180deg);\r\n  }\r\n  \r\n  .ctrlSelection {\r\n    transition: color 0.25s;\r\n  }\r\n  \r\n  .ctrlSelection {\r\n    background: linear-gradient(90deg, #97b8ef 50%, transparent 50%), linear-gradient(90deg, #97b8ef 50%, transparent 50%), linear-gradient(0deg, #97b8ef 50%, transparent 50%), linear-gradient(0deg, #97b8ef 50%, transparent 50%);\r\n    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\r\n    background-size: 15px 4px, 15px 4px, 4px 15px, 4px 15px;\r\n    background-position: 0px 0px, 200px 100px, 0px 100px, 200px 0px;\r\n    padding: 10px;\r\n    animation: border-dance 4s infinite linear;\r\n  }\r\n  \r\n  @keyframes border-dance {\r\n    0% {\r\n      background-position: 0px 0px, 300px 46px, 0 150px, 86px 0, 0px 4px\r\n    }\r\n  \r\n    100% {\r\n      background-position: 300px 0px, 160px 46px, 0 0, 86px 179px, 0px 28px\r\n    }\r\n  }\r\n  \r\n  .popover {\r\n    pointer-events: none;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Shift__Header__Text": `RQCalendar-module__Shift__Header__Text--d1Qf3`,
	"Settings__Header__Text": `RQCalendar-module__Settings__Header__Text--vsehb`,
	"Input_available": `RQCalendar-module__Input_available--nEUIe`,
	"Card__Container": `RQCalendar-module__Card__Container--rSP88`,
	"logoDrawer": `RQCalendar-module__logoDrawer--cKCm5`,
	"logoImg": `RQCalendar-module__logoImg--Gs_s1`,
	"logoEmployeeBillboard": `RQCalendar-module__logoEmployeeBillboard--UbLW9`,
	"logoPoweredBy": `RQCalendar-module__logoPoweredBy--D0CdN`,
	"Button__Location": `RQCalendar-module__Button__Location--FYIK6`,
	"Ascending": `RQCalendar-module__Ascending--gEZBC`,
	"Descending": `RQCalendar-module__Descending--BazkB`,
	"ctrlSelection": `RQCalendar-module__ctrlSelection--cyhla`,
	"border-dance": `RQCalendar-module__border-dance--qRo_K`,
	"popover": `RQCalendar-module__popover--YG1cl`
};
export default ___CSS_LOADER_EXPORT___;
